import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../../Components/Modal/modal.js';
import {
  SKILL_MAP_DASHBOARD,
  CANCEL_TEXT,
} from '../../../../Constants/strings.js';
import './deleteSkillMapDialog.scss';
import alertIcon from '../../../../Assets/images/svg/alert_icon.svg';

const DeleteDialog = ({
  handleCloseAction,
  handleDeleteAction,
  selectedItem,
  setIsDialogOpen,
  setFilteredList,
  setLevelFilteredList,
  handleSnackbar,
  setAnchorEl,
}) => {
  return (
    <FormDialog
      open={selectedItem !== null}
      title={SKILL_MAP_DASHBOARD.DELETE_SKILL_MAP}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="skill-map-dialog-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img alt="Alert Icon" className="icon-image" src={alertIcon} />
          </div>
          <div className="dialog-message-text">
            {SKILL_MAP_DASHBOARD.DELETE_SKILL_MAP_MESSAGE}
          </div>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId={'cancel-' + SKILL_MAP_DASHBOARD.DELETE_SKILL_MAP}
      button2={SKILL_MAP_DASHBOARD.DELETE_SKILL_MAP_BUTTON}
      submitButtonId={SKILL_MAP_DASHBOARD.DELETE_SKILL_MAP}
      button2Action={() =>
        handleDeleteAction(
          selectedItem,
          setFilteredList,
          setLevelFilteredList,
          setIsDialogOpen,
          handleSnackbar,
          setAnchorEl,
        )
      }
      button1Action={() => handleCloseAction(setIsDialogOpen)}
    />
  );
};

DeleteDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleDeleteAction: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  setFilteredList: PropTypes.func.isRequired,
  setLevelFilteredList: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
};

export default DeleteDialog;
